var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-wrapper"},[_c('div',{class:{
      'white-container--with-padding': !_vm.noWhiteContainer,
      'white-container--with-small-padding': _vm.smallPadding,
      'white-container--with-large-padding': _vm.largePadding,
      'full-width-on-mobile': _vm.fullWidthOnMobile,
      'no-bottom-padding': _vm.noBottomPadding,
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }